import { toast } from 'react-toastify';

export const getErrorMessage = (error, fallbackMessage) =>
    error?.response?.data?.message
    || error?.response?.data?.title
    || (typeof error?.response?.data === 'string' ? error.response.data : null)
    || fallbackMessage;

export const extractItemsFromResponse = (responseData) => {
    if (!responseData) {
        return null;
    }
    if (Array.isArray(responseData?.data?.items)) {
        return responseData.data.items;
    }
    if (responseData?.isSuccess && Array.isArray(responseData.data?.items)) {
        return responseData.data.items;
    }
    if (responseData?.isSuccess && responseData.data !== undefined) {
        return responseData.data;
    }
    if (Array.isArray(responseData?.data)) {
        return responseData.data;
    }
    if (responseData?.data !== undefined) {
        return responseData.data;
    }
    return responseData;
};

export const extractPagedItemsAndTotal = (responseData) => {
    const rawItems = extractItemsFromResponse(responseData);
    const total = responseData?.data?.total ?? responseData?.total ?? (Array.isArray(rawItems) ? rawItems.length : 0);
    return { rawItems, total };
};

export const shouldToastError = (error) => !error?.response
    || (error.response.status !== 401 && error.response.status !== 403 && error.response.status < 500);

export const handleApiError = (error, fallbackMessage, options = {}) => {
    const { toastPrefix = '' } = options;
    const message = getErrorMessage(error, fallbackMessage);
    if (shouldToastError(error)) {
        toast.error(`${toastPrefix}${message}`);
    }
    return message;
};
